namespace GeniuzPOS.Lookups {
    export namespace VwpsShopTypeService {
        export const baseUrl = 'Lookups/VwpsShopType';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwpsShopTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwpsShopTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwpsShopType/Retrieve",
            List = "Lookups/VwpsShopType/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwpsShopTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
